import { Rive } from "@rive-app/canvas";

export default function riveController() {
	return {
			riveInstances: {},
			isRiveHovered: false,
			cameraSound: new Audio('/dist/audio/camera-sound-effect.mp3'),

			init() {
					// Initialize sound
					this.cameraSound.load();

					// Initialize audio context on first user interaction
					document.addEventListener('click', () => {
							this.cameraSound.play().then(() => {
									this.cameraSound.pause();
									this.cameraSound.currentTime = 0;
							});
					}, { once: true });

					this.initRiveCanvases();
			},

			playSound() {
					if (this.cameraSound && !this.$store.audio.isMuted) {
							this.cameraSound.currentTime = 0;
							this.cameraSound.play().catch(() => {
									// If play fails, reinitialize and try again
									this.cameraSound = new Audio('/dist/audio/camera-sound-effect.mp3');
									this.cameraSound.load();
							});
					}
			},

			centerOnElement(element) {
					const mapContainer = document.querySelector('[x-ref="mapContainer"]');
					const map = document.querySelector('[x-ref="map"]');

					if (!mapContainer || !map || !element) return;

					// Get the dimensions
					const containerWidth = mapContainer.offsetWidth;
					const containerHeight = mapContainer.offsetHeight;
					const elementRect = element.getBoundingClientRect();
					const mapRect = map.getBoundingClientRect();
					const mapWidth = map.offsetWidth;
					const mapHeight = map.offsetHeight;

					// Calculate the element's position relative to the map
					const elementX = elementRect.left - mapRect.left;
					const elementY = elementRect.top - mapRect.top;

					// Calculate the center position
					let targetX = -(elementX - (containerWidth / 2) + (elementRect.width / 2));
					let targetY = -(elementY - (containerHeight / 2) + (elementRect.height / 2));

					// Apply boundaries
					const maxX = 0;
					const maxY = 0;
					const minX = -(mapWidth - containerWidth);
					const minY = -(mapHeight - containerHeight);

					// Clamp the target position within boundaries
					targetX = Math.min(maxX, Math.max(minX, targetX));
					targetY = Math.min(maxY, Math.max(minY, targetY));

					// Update the map position with animation
					map.style.transition = 'transform 0.5s ease-out';
					map.style.transform = `translate(${targetX}px, ${targetY}px)`;

					// Remove transition after animation
					setTimeout(() => {
							map.style.transition = '';
					}, 500);

					// Update Alpine.js x and y values
					if (this.$data) {
							this.$data.x = targetX;
							this.$data.y = targetY;
					}
			},

			initRiveCanvases() {
					const canvasElements = document.querySelectorAll("canvas[data-url]");

					canvasElements.forEach((canvas) => {
							const fileURL = canvas.dataset.url;
							const canvasID = canvas.id;
							const hoverSoundElement = document.getElementById(`hoverSound-${canvasID.split('-')[1]}`);

							// Add event listeners for hover state
							canvas.addEventListener("mouseenter", () => {
								if (canvas.getAttribute('data-not-trackable') == '1') return;

								this.isRiveHovered = true;
								canvas.classList.add("cursor-binocular");
								if (hoverSoundElement && !this.$store.audio.isMuted) {
									hoverSoundElement.volume = 1;
									hoverSoundElement.loop = true;
									hoverSoundElement.play().catch(console.error);
								}
							});

							canvas.addEventListener("mouseleave", () => {
								if (canvas.getAttribute('data-not-trackable') == '1') return;

								this.isRiveHovered = false;
								canvas.classList.remove("cursor-binocular");
								if (hoverSoundElement && !this.$store.audio.isMuted) {
									const fadeOut = setInterval(() => {
										if (hoverSoundElement.volume > 0.1) {
											hoverSoundElement.volume -= 0.1;
										} else {
											hoverSoundElement.pause();
											hoverSoundElement.currentTime = 0;
											clearInterval(fadeOut);
										}
									}, 50);
								}
							});

							// Function to handle the interaction
							const handleInteraction = () => {
								  if (this.$store.map.hasDraggedAboveThreshold || canvas.getAttribute('data-not-trackable') == '1') return;

									// Play camera sound
									this.playSound();

									// Center the map on the clicked element
									//this.centerOnElement(canvas);

									// Add flash class to body
									document.body.classList.add("flash-effect");

									// Remove flash class after animation completes
									setTimeout(() => {
											document.body.classList.remove("flash-effect");
									}, 150);

									// If there's a Rive instance for this canvas, trigger any click animations
									if (this.riveInstances[canvasID]) {
											const instance = this.riveInstances[canvasID];
											// Try to fire a click input or trigger a state change
											try {
													instance.fireState("State Machine 1", "click");
											} catch (e) {
													console.log("No click state found in Rive animation");
											}
									}

									// Update tracker progress
									if (this.$data.handleRiveClick) {
											this.$data.handleRiveClick(canvasID);
									}
							};

							// Add both click and touch event listeners
							canvas.addEventListener("click", handleInteraction);
							canvas.addEventListener("touchend", (e) => {
									e.preventDefault(); // Prevent default touch behavior
									handleInteraction();
							});

							if (fileURL) {
									const riveInstance = new Rive({
											src: fileURL,
											canvas: canvas,
											autoplay: true,
											clearCanvas: false,
											background: "transparent",
											stateMachines: ["State Machine 1"],
											onLoad: () => {
													riveInstance.resizeDrawingSurfaceToCanvas();
													this.riveInstances[canvasID] = riveInstance;
											},
									});
							} else {
									console.error(`No Rive URL provided for canvas ID "${canvasID}"`);
							}
					});
			},
	};
}
